/* eslint-disable import/prefer-default-export */
export const STATUS_GIFT_CODE = {
  SAVED: 'saved',
  PAID: 'paid',
  EXPIRED: 'expired',
  ACTIVE: 'active',
  DEACTIVATE: 'deactivate',
}
